import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

export const superadminGuard: CanActivateFn = async (_route, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn) {
    auth.saveRedirect(state.url);
    return router.createUrlTree(['/login']);
  }

  if (!auth.isSuperAdmin) {
    return router.createUrlTree([auth.homeRoute()]);
  }

  return true;
};
